import React, { Component } from 'react';
import '../componentform.css';
import componentMap from '../../../ComponentMap';
import ImageGalleryField from '../../../ImageGalleryField';
import { showConfirmation } from '../../../ConfirmationModal';
import { showNotification } from '../../../StatusNotification';

export class TeamMemberForm extends Component {
    static displayName = TeamMemberForm.name;

    constructor(props) {
        super(props);
        this.state = {
            teamMember: null,
            formType: null,
            pageId: this.props.pageId,
            versionId: this.props.versionId,
            versionStatus: this.props.versionStatus,
            teamGridId: this.props.teamGridId,
            isEditOnly: this.props.isEditOnly != undefined ? this.props.isEditOnly : false,
            isInPopup: this.props.isInPopup != undefined ? this.props.isInPopup : false
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.getComponentData();
    }

    handleChange = (e) => {
        let newTeamMember = this.state.teamMember;
        newTeamMember[e.target.name] = e.target.value;
        this.setState({ teamMember: newTeamMember });
    }

    handleSubmit = (e) => {
        e.preventDefault();

        let teamMember = this.state.teamMember;
        teamMember.versionId = this.state.versionId;
        teamMember.pageId = this.state.pageId;
        teamMember.teamGridId = this.state.teamGridId;

        let url = this.state.formType == "Update" ? "UpdateTeamMember" : "CreateTeamMember";
        fetch('Admin/' + url, {
            method: 'POST',
            body: JSON.stringify(teamMember),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then(
            response => response.json()
        ).then(
            data => {
                if (!isNaN(data)) {
                    this.props.onComponentSaved();
                }
                else {
                    showNotification(data, "error");
                }
            }
        );
    }

    render() {
        let deleteButton = this.state.formType == "Update" ? <button className='delete-btn' onClick={this.deleteComponent.bind(this)}>Delete</button> : null;
        if (this.state.isInPopup) {
            deleteButton = null;
        }

        let componentName;
        let name;
        let title;
        let photoUrl;
        if (this.state.teamMember != null) {
            let teamMember = this.state.teamMember;

            componentName = teamMember.componentName;
            name = teamMember.name;
            title = teamMember.title;
            photoUrl = teamMember.photoUrl;
        }

        let isImageGalleryFieldDisabled = this.state.versionStatus == 'draft' ? false : true;
        let wrapperClasses = this.state.versionStatus == 'draft' ? 'grid-wrapper component-form' : 'grid-wrapper component-form disable-form';
        return (
            <form id='teamMemberForm' onSubmit={this.handleSubmit.bind(this)} className={wrapperClasses}>
                <div className='tri-grid'>
                    <div className='tri-grid__1-3 form-title'>
                        <h2>{componentName} {componentMap.componentTypeDisplay('TeamMember')}</h2>
                    </div>

                    <label htmlFor='teamMember-componentName'>Label (admin only):</label>
                    <input id='teamMember-componentName' name='componentName' type='text' defaultValue={componentName} onChange={this.handleChange} required maxLength='15' />
                    <div></div>

                    <label htmlFor='teamMember-name'>Name: </label>
                    <input id='teamMember-name' name='name' type='text' defaultValue={name} onChange={this.handleChange} required />
                    <div></div>

                    <label htmlFor='teamMember-title'>Title: </label>
                    <input id='teamMember-title' name='title' type='text' defaultValue={title} onChange={this.handleChange} required />
                    <div></div>

                    <label>Photo: </label>
                    <div>
                        <input name='photoUrl' type='text' defaultValue={photoUrl} onChange={this.handleChange} hidden />
                        <ImageGalleryField name='photoUrl' currentImageUrl={photoUrl} handleImageChange={this.handleChange} isDisabled={isImageGalleryFieldDisabled} />
                    </div>
                    <div></div>

                    <div className='tri-grid__1-3'>
                        <button form='teamMemberForm' type='submit'>Save</button>
                        {deleteButton}
                    </div>
                </div>
            </form>
        );
    }

    async getComponentData() {
        let componentId = (this.props.componentId !== undefined) ? this.props.componentId : 0;
        let formType = this.props.formType !== undefined ? this.props.formType : 'Create';

        const response = await fetch('Admin/GetTeamMember?componentId=' + componentId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        this.setState({
            teamMember: data,
            formType: formType
        });
    }

    async deleteComponent(e) {
        e.preventDefault();
        let confirmDelete = await showConfirmation("Are you sure you want to delete this component and remove all associations to it?");

        if (confirmDelete) {
            const response = await fetch('Admin/DeleteTeamMember?componentId=' + this.state.teamMember.id, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });

            const data = await response.json();

            if (data === "Deleted") {
                this.props.onComponentDeleted();
            }
            else {
                showNotification(data, "error");
            }
        }
    }
}

export default TeamMemberForm;
